import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../global/functions/apiClient";
import { getAuthHeaders } from "../global/functions/authorization";
const apiUrl = process.env.REACT_APP_API_URL;
const initialState = {
  items: [],
  status: "idle",
  error: null,
  success: null,
  loading: false,
};

export const getTypeVariations = createAsyncThunk(
  "typeVariation/getTypeVariations",
  async (restaurantId) => {
    try {
      const response = await axios.get(
        `${apiUrl}/typeVariation`,
        getAuthHeaders(false, restaurantId)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);

export const addTypeVariation = createAsyncThunk(
  "typeVariation/addTypeVariation",
  async ({ body, restaurantId }) => {
    try {
      const response = await axios.post(
        `${apiUrl}/typeVariation`,
        body,
        getAuthHeaders(false, restaurantId)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);

export const modifyTypeVariation = createAsyncThunk(
  "typeVariation/modifyTypeVariation",
  async ({ body, typeVariationId, restaurantId }) => {
    try {
      const response = await axios.put(
        `${apiUrl}/typeVariation/${typeVariationId}`,
        body,
        getAuthHeaders(false, restaurantId)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);

export const deleteTypeVariation = createAsyncThunk(
  "typeVariation/deleteTypeVariation",
  async ({ typeVariationId, restaurantId }) => {
    try {
      const response = await axios.delete(
        `${apiUrl}/typeVariation/${typeVariationId}`,
        getAuthHeaders(false, restaurantId)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);

const typeVariationSlice = createSlice({
  name: "typeVariation",
  initialState,
  reducers: {
    updateStatus: (state) => {
      state.status = "idle";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getTypeVariations.pending, (state, action) => {
        state.status = "loadingFetchTypeVariation";
        state.loading = true;
      })
      .addCase(getTypeVariations.fulfilled, (state, action) => {
        state.status = "fetchTypeVariation";
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getTypeVariations.rejected, (state, action) => {
        state.status = "fetchError";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addTypeVariation.pending, (state, action) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(addTypeVariation.fulfilled, (state, action) => {
        state.status = "addSuccess";
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(addTypeVariation.rejected, (state, action) => {
        state.status = "addError";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteTypeVariation.pending, (state, action) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(deleteTypeVariation.fulfilled, (state, action) => {
        state.status = "deleteSuccess";
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(deleteTypeVariation.rejected, (state, action) => {
        state.status = "deleteError";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(modifyTypeVariation.pending, (state, action) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(modifyTypeVariation.fulfilled, (state, action) => {
        state.status = "modifySuccess";
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(modifyTypeVariation.rejected, (state, action) => {
        state.status = "modifyError";
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export const { updateStatus } = typeVariationSlice.actions;
export const selectAllTypeVariations = (state) => state.typeVariation.items;
export const getTypeVariationStatus = (state) => state.typeVariation.status;
export const getTypeVariationError = (state) => state.typeVariation.error;
export const getTypeVariationSuccess = (state) => state.typeVariation.success;
export const getTypeVariationLoading = (state) => state.typeVariation.loading;
export default typeVariationSlice.reducer;
